import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import { CWV_ROUTES, isDocumentPrototypeRoute } from '@sketch/modules-common'

import { SearchField } from './DocumentNavbar.styles'
import { useSearch } from 'modules/shares/hooks/useSearch'

const getPlaceholderByPath = (path: string) => {
  if (CWV_ROUTES.includes(path)) {
    return 'Search Components'
  } else if (isDocumentPrototypeRoute(path)) {
    return 'Search Prototypes'
  }

  return 'Search Artboards'
}

interface DocumentNavbarProps
  extends Pick<React.ComponentProps<'input'>, 'onBlur' | 'onFocus'> {}

const DocumentNavbar = (props: DocumentNavbarProps) => {
  const { path } = useRouteMatch()

  // Search query param, shared for both artboards and components
  const { search, setSearch } = useSearch()

  return (
    <SearchField
      placeholder={getPlaceholderByPath(path)}
      onChange={setSearch}
      value={search}
      expand={CWV_ROUTES.includes(path) || isDocumentPrototypeRoute(path)}
      {...props}
    />
  )
}

export default DocumentNavbar
